module.exports = __webpack_public_path__ + "media/img/favicon/favicon-32x32-8405b8ce7a0ac15d8b78658ae3679708.png";